function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.1066 2.70585H5.12236V9.2071C5.12236 9.40196 4.9643 9.56001 4.76944 9.56001C4.57458 9.56001 4.41652 9.40196 4.41652 9.2071V2.35293C4.41652 2.15807 4.57458 2.00002 4.76944 2.00002H13.3419C13.4363 2.00002 13.5258 2.03774 13.5925 2.1044L15.8808 4.3927C15.9471 4.45902 15.9841 4.54844 15.9841 4.64223L15.9841 9.20709C15.9841 9.40195 15.8261 9.56001 15.6312 9.56001C15.4364 9.56001 15.2783 9.40195 15.2783 9.20709V4.87749H14.4866C14.1069 4.87749 13.7618 4.72231 13.5118 4.47233C13.2618 4.22234 13.1067 3.8773 13.1067 3.49757V2.70584L13.1066 2.70585ZM5.12236 17.2942H15.2783V15.4553C15.2783 15.2604 15.4364 15.1024 15.6312 15.1024C15.8261 15.1024 15.9841 15.2604 15.9841 15.4553V17.6471C15.9841 17.842 15.8261 18 15.6312 18H4.76942C4.57456 18 4.4165 17.842 4.4165 17.6471V15.4553C4.4165 15.2604 4.57456 15.1024 4.76942 15.1024C4.96428 15.1024 5.12234 15.2604 5.12234 15.4553V17.2942H5.12236Z",
  fill: "#99A6B0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.78418 6.05368H13.6163V6.64189H6.78418V6.05368Z",
  fill: "#99A6B0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.78418 7.44949H13.6163V8.0377H6.78418V7.44949Z",
  fill: "#99A6B0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.78418 4.65773H11.6147V5.24594H6.78418V4.65773Z",
  fill: "#99A6B0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.46789 13.8242V10.8381H9.07068V13.8242H8.46789ZM9.64565 13.8242V10.8381H10.6128C10.9792 10.8381 11.2183 10.8534 11.3296 10.8833C11.5006 10.9278 11.6445 11.0251 11.7599 11.1753C11.8753 11.3255 11.9331 11.5195 11.9331 11.7565C11.9331 11.9401 11.8997 12.0944 11.8329 12.2189C11.7662 12.344 11.6821 12.4421 11.5792 12.5137C11.477 12.5846 11.3727 12.6319 11.267 12.6548C11.1231 12.6833 10.9145 12.6979 10.6413 12.6979H10.2484V13.8242H9.64565L9.64565 13.8242ZM5.12249 15.6906H15.2784H15.9843H17.1656C17.2956 15.6906 17.4009 15.5852 17.4009 15.4553V9.20707C17.4009 9.07712 17.2956 8.97177 17.1656 8.97177H15.9843H15.2784H5.12249H4.41665H3.2353C3.10535 8.97177 3 9.07712 3 9.20707V15.4553C3 15.5852 3.10535 15.6906 3.2353 15.6906H4.41665H5.12249Z",
  fill: "#99A6B0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.2485 11.3435V12.1904H10.5781C10.8159 12.1904 10.9751 12.1751 11.055 12.1438C11.135 12.1125 11.1976 12.0638 11.2435 11.9971C11.2886 11.9303 11.3116 11.8532 11.3116 11.7649C11.3116 11.6564 11.2796 11.5667 11.2156 11.4958C11.1524 11.4256 11.071 11.3811 10.9737 11.3637C10.9014 11.3498 10.7568 11.3435 10.5399 11.3435H10.2485L10.2485 11.3435Z",
  fill: "#99A6B0"
});

const SvgIpWhitelist = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIpWhitelist, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ip-whitelist.aeaed916.svg";
export { ForwardRef as ReactComponent };